import React, { memo, useMemo } from 'react';
import classnames from 'classnames/bind';
import { withScreenResizeDetectHoc, } from '@wildberries/ui-kit';
import { SliderInfoCardsSkeleton } from './_components/slider-info-cards-skeleton';
import { getCardsConfig } from './_utils';
import { Skeleton } from './_components/skeleton';
import styles from './index.module.scss';
var cn = classnames.bind(styles);
var BLOCK_NAME = 'HomePagePreview';
export var WraooedComponent = memo(function (_a) {
    var screenType = _a.screenType;
    var cardsConfig = useMemo(function () { return getCardsConfig({ screenType: screenType }); }, [
        screenType,
    ]);
    return (React.createElement("div", { className: cn(BLOCK_NAME) },
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__slider-info")) },
            React.createElement(SliderInfoCardsSkeleton, null)),
        React.createElement("ul", { className: cn("".concat(BLOCK_NAME, "__cards")) }, cardsConfig.map(function (_a) {
            var colSize = _a.colSize, id = _a.id;
            return (React.createElement("li", { key: id, className: cn("".concat(BLOCK_NAME, "__cards-item"), "".concat(BLOCK_NAME, "__cards-item--col-size-").concat(colSize)) },
                React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__skeleton"), "".concat(BLOCK_NAME, "__skeleton--full-height")) },
                    React.createElement(Skeleton, null))));
        }))));
});
export var HomePagePreview = withScreenResizeDetectHoc({})(WraooedComponent);
